import m from "../../geodata/es2015/arubaLow";
window.am4geodata_arubaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/arubaLow.js
// module id = null
// module chunks = 